import axios from "axios";

/**
 * 家属端专用 axios，与管理端全局拦截器隔离
 */
const familyHttp = axios.create({
  baseURL: "/",
  timeout: 30000,
});

familyHttp.interceptors.request.use((config) => {
  let url = config.url || "";
  if (!/^https?:\/\//i.test(url) && url.charAt(0) !== "/") {
    url = `/${url}`;
  }
  config.url = url;
  const isAuthApi = url.indexOf("/web/family/auth/") !== -1;
  const token = sessionStorage.getItem("familyToken");
  if (!isAuthApi && token) {
    config.headers.Authorization = token;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

familyHttp.interceptors.response.use(
  (res) => {
    const body = res && res.data;
    if (body && body.code == 9006) {
      sessionStorage.removeItem("familyIsLogin");
      sessionStorage.removeItem("familyToken");
      sessionStorage.removeItem("familyUser");
      return Promise.reject(new Error(body.msg || "未登录"));
    }
    return res;
  },
  (error) => Promise.reject(error)
);

export default familyHttp;
